import {
  Actions,
  Breadcrumb,
  Button,
  ErrorAlert,
  Input,
  Modal,
  modalHandler,
  ModalOpenBtn,
  PageHero,
  success,
  Table,
  updateList,
  UploadImageCard,
  useCustomForm,
  useDelete,
  useFetchData,
  UserGroupIcon,
  useState,
  useTableColumns,
} from "@";
import { fillForm } from "./utils/helpers";
import tableColumns from "./components/tableColumns";
import { defaultValues, schema } from "./utils/validation";
import { getOurPartners, saveOurPartners } from "./utils/api";

const Index = () => {
  // Breadcrumb links
  const links = [{ name: "شركاؤنا", link: "" }];
  const [isEdit, setIsEdit] = useState(false);

  // Table columns configuration
  const columns = useTableColumns(tableColumns, (row) => (
    <>
      <Actions notShow row={row} edit={handlerEdit} delete={deleteHandler} />
    </>
  ));

  // Use form
  const {
    reset,
    watch,
    errors,
    register,
    setValue,
    handleSubmit,
    isSubmitting,
    isSubmitSuccessful,
  } = useCustomForm(defaultValues, schema);

  // Fetch data
  const { data, setData, isLoading, error, fetchData } = useFetchData({
    noPgn: true,
    fun: getOurPartners,
  });

  // Delete handler
  const { deleteHandler } = useDelete(data, setData, "partners");

  // Clear form
  const clearForm = () => {
    setIsEdit(false);
    reset(defaultValues);
  };

  // Edit handler
  const handlerEdit = (item) => {
    reset(fillForm(item));
    setIsEdit(true);
    modalHandler();
  };

  // Save data
  const submit = async (form) => {
    try {
      const { data: newValue } = await saveOurPartners(form);
      setData(updateList(data, newValue));
      success("تم الحفظ بنجاح");
      modalHandler();
      clearForm();
    } catch (error) {}
  };

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      {/* Modal for add/edit partner */}
      <Modal close={clearForm} title={isEdit ? "تعديل" : "اضافة"}>
        <form onSubmit={handleSubmit(submit)} className="p-2 md:p-5">
          <Input
            style="mb-5"
            label="العنوان"
            error={errors.Title}
            input={register("Title")}
          />

          <Input
            style="mb-7"
            label="الرابط"
            error={errors.Link}
            input={register("Link")}
          />

          <UploadImageCard
            show={true}
            title="الصورة"
            src={watch("imageFullUrl")}
            success={isSubmitSuccessful}
            error={errors.Image?.message}
            upload={(file) => setValue("Image", file)}
          />

          <Button isLoading={isSubmitting} type="submit" title="حفظ البيانات" />
        </form>
      </Modal>

      <main className="table-card relative">
        <PageHero
          eyebrow="الموقع / شركاؤنا"
          title="شركاؤنا"
          count={data?.length}
          icon={UserGroupIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <ModalOpenBtn title="اضافة" />
        </PageHero>

        {/* Table */}
        <Table localPg data={data} columns={columns} isLoading={isLoading} />
      </main>
    </>
  );
};

export default Index;
